import { render, staticRenderFns } from "./product-price-block.vue?vue&type=template&id=0b145d7e&"
import script from "./product-price-block.vue?vue&type=script&lang=js&"
export * from "./product-price-block.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports